import SubHeaders from '@/components/Headers/SubHeaders'
import { useTranslation } from 'react-i18next'
import { paths } from '@/utils/path'
import useTabs from '@/hooks/useTabs'
import { Tabs } from 'vnetwork-ui'
import Analytics from './components/Analytics'
import List from './components/List'
import CustomerMovements from './components/CustomerMovements'
import { SalesTargetFilters } from '../BusinessTargets/types'
import { useForm } from 'react-hook-form'
import Filters from '../BusinessTargets/components/shared/Filters'
import useAuthStore from '@/stores/useAuthStore'
import usePermissionsStore from '@/stores/usePermissionsStore'
import { useEffect } from 'react'
import { getEmployeesOptions } from '@/modules/Employee/services'
import { DEPARTMENT_IDS } from '@/constants/departments'

const DEFAULT_DEPARTMENT_IDS = [DEPARTMENT_IDS.ACCOUNT, DEPARTMENT_IDS.SALES]

export default function TargetAnalytics() {
    const { employee } = useAuthStore()
    const { isAdmin } = usePermissionsStore()
    const { t } = useTranslation('report')
    const currentYear = new Date().getFullYear()

    const { control, watch, setValue } = useForm<SalesTargetFilters>({
        defaultValues: {
            employee_id: isAdmin ? [] : [employee?.employee_id],
            department_ids: [],
            product_group_name: undefined,
            gte: `${currentYear}-01-01`,
            lte: `${currentYear}-12-31`,
        },
    })

    const filters = watch()

    // Set default department and fetch employees when admin
    useEffect(() => {
        const initAdminDefaults = async () => {
            if (isAdmin) {
                setValue('department_ids', DEFAULT_DEPARTMENT_IDS)
                // Manually fetch employees since setValue doesn't trigger onChangeAfterHookForm
                const employees = await getEmployeesOptions(
                    '',
                    DEFAULT_DEPARTMENT_IDS,
                    'active'
                )
                setValue(
                    'employee_id',
                    employees?.map((emp) => emp.value as number) ?? [],
                    { shouldDirty: true }
                )
            }
        }
        initAdminDefaults()
    }, [isAdmin, setValue])

    const { TabProps, TabComponent } = useTabs({
        tabs: [
            {
                label: t('target_analytics.analytics'),
                value: 'analytics',
                component: <Analytics filters={filters} />,
            },
            {
                label: t('target_analytics.list'),
                value: 'list',
                component: <List filters={filters} />,
            },
            {
                label: 'Báo cáo CS',
                value: 'customer-movements',
                component: <CustomerMovements filters={filters} />,
            },
        ],
    })

    return (
        <div>
            <SubHeaders
                breadcrumbs={[
                    {
                        title: t('target_analytics.title'),
                        path: paths.reportTargetAnalytics,
                    },
                ]}
                actions={[]}
            />
            {/* Filters */}
            <div data-tour="target-analytics-filters">
                <Filters
                    control={control}
                    setValue={setValue}
                    hideProductGroupSelect
                    hideDepartmentSelect={!isAdmin}
                    disabledEmployeeSelect={!isAdmin}
                />
            </div>
            <div data-tour="target-analytics-tabs" className="mb-2">
                <Tabs {...TabProps} />
            </div>
            {TabComponent}
        </div>
    )
}
